import React from 'react';
import {Pagination} from '../pagination';
import SearchPaginationDataDisplay from '../search-pagination-data-display';
import { SearchResultsSortV2 } from '../search-results-sort-v2';
import {
  StyledPaginationContainer,
  StyledPaginationContentContainer,
  StyledPaginationFooterContainer,
  StyledPaginationHeaderContainer,
} from './styles';

interface SearchPaginationProps {
  children: React.ReactNode;
  currentPage: number;
  distance: string;
  loadingStatus: string;
  pageSize: number;
  sortByValue: string;
  totalPages: number;
  totalVehicles: number | Number;
  onHandlePageChange: (pageNumber) => void;
  onHandleSortChange: (option?: string) => void;
}
const SearchPagination: React.FC<SearchPaginationProps> = (props) => {
  const {
    children,
    loadingStatus,
    totalPages,
    sortByValue,
    currentPage,
    onHandlePageChange,
    onHandleSortChange,
  } = props;
  return (
    <StyledPaginationContainer className="search-pagination_main-container">
      <StyledPaginationHeaderContainer className="search-pagination_header-container">
        <SearchPaginationDataDisplay {...props} />
        <div className="divider" />
        {!!totalPages && (
          <SearchResultsSortV2
            onHandleSelectedSort={onHandleSortChange}
            sortByValue={sortByValue}
          />
        )}
      </StyledPaginationHeaderContainer>
      <StyledPaginationContentContainer className="search-pagination_content-container">
        {children}
      </StyledPaginationContentContainer>
      {loadingStatus === 'loaded' && !!totalPages && (
        <StyledPaginationFooterContainer className="search-pagination_footer-container">
          <Pagination
            totalPages={totalPages}
            currentPage={currentPage}
            setCurrentPage={onHandlePageChange}
          />
        </StyledPaginationFooterContainer>
      )}
    </StyledPaginationContainer>
  );
};

export default SearchPagination;
